import React from "react";
import Link from "next/link";
import { SbEditableBlok, sbEditable } from "@storyblok/storyblok-editable";
import clsx from "clsx";
import { eventName, pageName, section } from "../../../../constants/events/eventName";
import { trackUserActivity } from "../../../../services/trackUserActivity";

export interface NavLinkV2Props {
  blok: Partial<SbEditableBlok> & {
    link: {
      linktype: string;
      url?: string;
      cached_url?: string;
      id?: string;
      fieldtype?: string;
      prep?: boolean;
    };
    colorChangeonHover?: boolean;
    navLinkName: string;
  };
  additionalNavLinkClassName?: string;
  blokClassName?: string;
  key?: string;
}

export function NavLinkV2({
  blok: { link, colorChangeonHover: colorChangeOnHover, navLinkName, ...blokData },
  additionalNavLinkClassName = "",
  blokClassName,
  key
}: NavLinkV2Props) {
  let interLink = "";
  if (link?.cached_url?.includes("/en")) {
    interLink = link.cached_url.slice(3);
  } else {
    interLink = link?.cached_url || "";
  }

  const trackEvent = (blok: NavLinkV2Props["blok"]) => {
    const url = blok?.link?.linktype === "story" ? interLink : blok?.link?.url;
    trackUserActivity({
      page: pageName.HOME_PAGE,
      section: section.HEADER,
      eventName: eventName.CATEGORY_VIEW,
      details: {
        Page_url: url,
        category_name: blok.navLinkName
      }
    });
  };

  const linkTextClass = clsx(
    {
      "text-sm hover:black ": true,
      "hover:text-primary": colorChangeOnHover
    },
    additionalNavLinkClassName
  );

  return (
    <div className={blokClassName} key={key}>
      <button
        {...sbEditable(blokData as SbEditableBlok)}
        className="w-auto cursor-pointer block"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          trackEvent({ link, colorChangeOnHover, navLinkName, ...blokData });
        }}
        type="button"
      >
        <Link prefetch={false} passHref href={link?.linktype === "story" ? interLink : link?.url || ""}>
          <span className={linkTextClass} aria-label={navLinkName} data-testid="link-text">
            {navLinkName}
          </span>
        </Link>
      </button>
    </div>
  );
}
